var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var visualPicker = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -6px -12px -6px',
    width: '100%',
};
var itemBase = {
    backgroundColor: '#f5f5f5',
    border: '1px solid #cccccc',
    borderColor: '#8d8d8d',
    borderRadius: 4,
    boxSizing: 'border-box',
    color: '#222222',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 6px 12px 6px',
    padding: 0,
    textAlign: 'left',
    position: 'relative',
};
export var itemColumns = function (columns) {
    var _a;
    return (_a = {
            flexBasis: "calc((100%/".concat(columns, ") - 12px)")
        },
        _a["@media ".concat(mobile(860))] = {
            flexBasis: columns > 1 ? "calc((100%/".concat(columns - 1, ") - 12px)") : 'calc(100% - 12px)',
        },
        _a["@media ".concat(mobile(700))] = {
            flexBasis: 'calc(100% - 12px)',
        },
        _a);
};
export var beforeBorder = {
    ':before': {
        content: '""',
        width: 'calc(100% - 2px)',
        height: 'calc(100% - 2px)',
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '-1px',
        left: '-1px',
        borderColor: 'inherit',
        borderStyle: 'solid',
        borderWidth: '2px',
        borderRadius: 'inherit',
    },
};
export var focus = {
    outline: 'none',
    '--box-shadow-color': '#085a7e',
    ':after': {
        borderRadius: 4,
        bottom: -2,
        boxShadow: '0 0 0 2px var(--box-shadow-color)',
        content: '""',
        display: 'block',
        left: -2,
        pointerEvents: 'none',
        position: 'absolute',
        right: -2,
        top: -2,
        zIndex: 1,
    },
    ':active': {
        ':after': {
            display: 'none',
        },
    },
};
export var resetFocus = {
    ':after': {
        display: 'none',
    },
    ':active': {
        ':after': {
            display: 'none',
        },
    },
};
export var item = __assign(__assign({}, itemBase), { ':hover:not(:disabled)': __assign(__assign({}, beforeBorder), { backgroundColor: '#eaeaea', borderColor: '#11779c', boxShadow: '0 5px 5px rgba(0,0,0,0.2)', cursor: 'pointer', '.visual-picker-footer': {
            backgroundColor: '#dadada',
        } }), ':focus:not(:disabled)': focus, ':focus:not(:focus-visible):not(:disabled)': resetFocus, ':focus-visible:not(:disabled)': focus, ':active:not(:disabled)': __assign(__assign({}, beforeBorder), { backgroundColor: '#11779c', borderColor: '#11779c', color: "".concat('#ffffff', " !important"), '& .vp-item-description-2l34kj': {
            color: '#ffffff',
        }, '& .vp-item-icon-2l34kj': {
            color: '#ffffff',
        }, '& .vp-item-user-icon-2l34kj': {
            color: '#ffffff',
        }, '& .visual-picker-footer': {
            backgroundColor: '#11779c',
            color: '#ffffff',
        } }) });
export var componentTop = {
    display: 'flex',
    flexGrow: 0,
    flexShrink: 0,
    paddingTop: 14,
    paddingBottom: 14,
    paddingLeft: 20,
    paddingRight: 12,
    width: '100%',
    boxSizing: 'border-box',
};
export var footer = {
    color: '#666666',
    fontSize: 12,
    borderRadius: "0 0 ".concat(4, "px ").concat(4, "px"),
    backgroundColor: '#eaeaea',
    marginTop: 'auto',
    padding: '8px 20px',
    display: 'flex',
    width: '100%',
    boxSizing: 'border-box',
};
export var footerDisabled = __assign(__assign({}, footer), { color: "".concat('#8d8d8d', " !important"), cursor: 'not-allowed' });
export var footerLeft = {
    flexGrow: '1',
};
export var footerRight = {
    flexShrink: '1',
};
export var iconContainer = {
    paddingRight: 12,
    color: '#666666',
};
export var textContainer = {
    flexGrow: 1,
};
export var imageContainer = {
    left: 0,
    top: 0,
    height: "".concat(48, "px"),
    minWidth: "".concat(48, "px"),
    maxWidth: 52,
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginRight: 12,
};
export var label = {
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 18 + 'px',
};
export var description = {
    color: '#666666',
    fontSize: 12,
    lineHeight: 20 + 'px',
    paddingTop: 2,
};
export var selected = __assign(__assign(__assign({}, item), beforeBorder), { borderColor: '#11779c', paddingRight: 0, '& .vp-item-icon-2l34kj': {
        color: '#11779c',
    }, ':active': __assign(__assign({}, item[':active']), { '& .vp-item-icon-2l34kj': {
            color: '#ffffff',
        } }), ':disabled': {
        borderColor: '#a6a6a6',
        '& .vp-item-icon-2l34kj': {
            color: '#a6a6a6',
        },
    } });
export var selectedDisabled = {
    paddingRight: 0,
};
export var selectedIconContainer = {
    paddingLeft: 8,
};
export var disabled = __assign(__assign({}, itemBase), { backgroundColor: '#f5f5f5', color: "".concat('#8d8d8d', " !important"), cursor: 'not-allowed', '& .vp-item-description-2l34kj': {
        color: '#8d8d8d',
    }, '& .vp-item-user-icon-2l34kj': {
        color: '#8d8d8d',
    }, borderColor: '#a6a6a6' });
export var error = {
    border: '2px solid #c8102e',
};
export var itemImage = {
    width: '100%',
};
export var itemImageDisabled = {
    opacity: '20%',
};
export var imageCircle = {
    borderRadius: '50%',
};
export var imageSquare = {
    borderRadius: 0,
};
